import React from 'react';
import './bottomnav.css';
import { NavLink } from 'react-router-dom';
import home from '../assets/home.svg';
import ticket from '../assets/ticket.svg';
import map from '../assets/map.svg';
import schedule from '../assets/schedule.svg';
import plus from '../assets/plus.svg';
// import navbg from '../assets/navbg.svg';


const Bottomnav = () => {
  const navIconClass = ({ isActive }) => `nav_icon${isActive ? ' active_nav' : ''}`;
  const plusClass = ({ isActive }) => `plus_btn${isActive ? ' active_plus' : ''}`;

  return (
    <nav className='bottom_nav_wrapper'>

      <div className='nav_content'>
        <div className='nav_left'>
          <NavLink className={navIconClass} to='/home' aria-label="Home">
            <img src={home} alt='' />
          </NavLink>

          <NavLink className={navIconClass} to='/map' aria-label="Map">
            <img src={map} alt='' />
          </NavLink>
        </div>


        <div className='nav_right'>
          <NavLink className={navIconClass} to='/ticket' aria-label="Ticket">
            <img src={ticket} alt='' />
          </NavLink>

          <NavLink className={navIconClass} to='/schedule' aria-label="Schedule">
            <img src={schedule} alt='' />
          </NavLink>
        </div>
        
      </div>

      <NavLink className={plusClass} to='/booking' aria-label="Book tickets">
        <img src={plus} alt='' />
      </NavLink>
    </nav>
  );
}

export default Bottomnav;
